import { createSlice } from "@reduxjs/toolkit";

const tourDetailSlice = createSlice({
  name: "tourDetail",
  initialState: {
    tourData: {},
    loading: false,
    error: false,
  },
  reducers: {
    getTour: (state) => {
      state.loading = true;
      state.error = false;
    },
    getTourSuccess: (state, action) => {
      state.loading = false;
      state.tourData = action.payload.data
      state.error = false;
    },
    getTourFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    addFavorite: (state) => {
      state.loading = true;
      state.error = false;
    },
    addFavoriteSuccess: (state, action) => {
      state.tourData.favorite = action.payload.data
      state.loading = false;
      state.error = false;
    },
    addFavoriteFailed: (state) => {
      state.loading = false;
      state.error = false;
    },
    removeFavorite: (state) => {
      state.loading = true;
      state.error = false;
    },
    removeFavoriteSuccess: (state) => {
      state.tourData.favorite = null
      state.loading = false;
      state.error = false;
    },
    removeFavoriteFailed: (state) => {
      state.loading = false;
      state.error = false;
    },

  },
});

export const tourDetailActions = tourDetailSlice.actions;
export default tourDetailSlice.reducer;
